import { createFileRoute, Navigate } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/AppShell";
import { useAuth } from "@/lib/auth-context";
import { useMe } from "@/lib/query-hooks";

export const Route = createFileRoute("/profile")({
  head: () => ({
    meta: [
      { title: "Profile · PN-CivilServices" },
      { name: "description", content: "Your account and preferences." },
      { property: "og:title", content: "Profile · PN-CivilServices" },
      { property: "og:description", content: "Your account and preferences." },
    ],
  }),
  component: Profile,
});

function Profile() {
  const { user, loading, signOut } = useAuth();
  const { data: me } = useMe();

  if (!loading && !user) return <Navigate to="/login" />;

  return (
    <AppShell>
      <div className="mx-auto max-w-2xl px-4 pt-12 pb-24">
        <div className="label-card">Profile</div>
        <h1 className="mt-1 font-display text-3xl font-semibold">
          {me?.displayName ?? user?.displayName ?? "Your account"}
        </h1>
        <p className="mt-1 text-ink-soft">{user?.email}</p>
        {me?.role ? (
          <div className="mt-1 text-xs text-paprika label-card">
            Role · {me.role}
          </div>
        ) : null}

        <div className="mt-10 card-ledger p-6 space-y-4">
          <Row label="UID" value={user?.uid ?? "—"} mono />
          <Row label="Provider" value={user?.providerData[0]?.providerId ?? "—"} />
          <Row label="Verified" value={user?.emailVerified ? "Yes" : "No"} />
        </div>

        <button
          onClick={() => signOut()}
          className="mt-8 text-sm text-danger hover:underline"
        >
          Sign out of this device
        </button>
      </div>
    </AppShell>
  );
}

function Row({ label, value, mono }: { label: string; value: string; mono?: boolean }) {
  return (
    <div className="flex justify-between items-center gap-4">
      <div className="label-card">{label}</div>
      <div className={mono ? "font-mono text-xs text-ink-soft" : "text-sm"}>{value}</div>
    </div>
  );
}
